import { createBuilder } from '@rocicorp/zero'
import { schema } from './schema.ts'

// Shared ZQL query builders for our schema. Used by queries.ts to define named
// queries, and by mutators.ts to read inside a transaction via `tx.run(...)`.
export const builder = createBuilder(schema)
